import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  LinearProgress,
  Typography,
  makeStyles,
  colors
} from '@material-ui/core';
import InsertChartIcon from '@material-ui/icons/InsertChartOutlined';
import { store } from '../../../_helpers';
const useStyles = makeStyles(() => ({
  root: {
    height: '100%'
  },
  avatar: {
    backgroundColor: colors.orange[600],
    height: 56,
    width: 56
  }
}));

const TasksProgress = ({ className, ...rest }) => {
  const classes = useStyles();
  const [customers, setCustomer] = useState();
  useEffect(() => {
    // console.log('customers', customers, user);
    getdata();
  }, []);

  const getdata = async () => {
    let { user } = store.getState().authentication;
    try {
      await fetch(
        process.env.REACT_APP_BASE_URL +
          `/v10/user/${user?.id}?token=${user?.token}`
      )
        .then(response => response.json())
        .then(data => {
          // setusera(data.results[0]);
          var u = data.results[0];
          console.log(u, 'user');
          var request = '';
          var req = 0;
          switch (u.SubscriptionType) {
            case 'basic':
              request = '1,000';
              req = 1000;
              break;
            case 'standard':
              request = '10,000';
              req = 10000;
              break;
            case 'premium':
              request = '100,000';
              req = 100000;
              break;
          }
          u.request = request;
          u.req = req;
          setCustomer(u);
        });
    } catch (er) {
      console.log(er);
    }
  };
  return (
    <Card className={clsx(classes.root, className)} {...rest}>
      <CardContent>
        <Grid container justify="space-between" spacing={3}>
          <Grid item>
            <Typography color="textSecondary" gutterBottom variant="h6">
              Your API Key:
            </Typography>
            <Typography color="textSecondary" gutterBottom variant="h6">
              {customers?.apiKey}
            </Typography>
            <Typography color="textSecondary" gutterBottom variant="h6">
              Total Request
            </Typography>
            <Typography color="textPrimary" variant="h3">
              {customers?.totalCall}
            </Typography>
            <Typography color="textSecondary" gutterBottom variant="h6">
              Reamining Subscription
            </Typography>
            <Typography color="textPrimary" variant="h3">
              {customers?.remainingSubscription}
            </Typography>
            <Typography color="textSecondary" gutterBottom variant="h6">
              Total Request for this Subcription
            </Typography>
            <Typography color="textPrimary" variant="h3">
              {customers?.request}
            </Typography>
            <Typography color="textSecondary" gutterBottom variant="h6">
              Request Remaining
            </Typography>
            <Typography color="textPrimary" variant="h3">
              {customers?.noOfRequestRemaining} ({' '}
              {Math.floor(
                (customers?.noOfRequestRemaining / customers?.req) * 100
              )}
              % )
            </Typography>
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar}>
              <InsertChartIcon />
            </Avatar>
          </Grid>
        </Grid>
        <Box mt={3}>
          <LinearProgress
            value={Math.floor(
              (customers?.noOfRequestRemaining / customers?.req) * 100
            )}
            variant="determinate"
          />
        </Box>
      </CardContent>
    </Card>
  );
};

TasksProgress.propTypes = {
  className: PropTypes.string
};

export default TasksProgress;
